import { EndDatePicker } from "components/EndDatePicker";
import { MachineDropdown } from "components/AlertsManagement/AlertsTable/MachineDropdown";
import { SeverityDropdown } from "components/AlertsManagement/AlertsTable/SeverityDropdown";
import { SiteDropdown } from "components/AlertsManagement/AlertsTable/SiteDropdown";
import { StartDatePicker } from "components/StartDatePicker";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";

export function AlertTableControls({
  filters,
  onFilterChange,
  startDateLabel = undefined,
  endDateLabel = undefined
}) {
  const {
    severityFilter,
    siteFilter,
    machineFilter,
    startDateFilter,
    endDateFilter
  } = filters;

  return (
    <Row>
      <DropdownGroup>
        <DropdownWrapper>
          <SeverityDropdown
            value={severityFilter}
            onChange={value =>
              onFilterChange(prevFilters => {
                return { ...prevFilters, severityFilter: value };
              })
            }
            size="small"
            fullWidth
          />
        </DropdownWrapper>
        <DropdownWrapper>
          <SiteDropdown
            value={siteFilter}
            onChange={(evt, value) =>
              onFilterChange(prevFilters => {
                return { ...prevFilters, siteFilter: value };
              })
            }
            size="small"
            fullWidth
          />
        </DropdownWrapper>
        <DropdownWrapper>
          <MachineDropdown
            value={machineFilter}
            siteId={siteFilter?.id}
            onChange={(evt, value) =>
              onFilterChange(prevFilters => {
                return { ...prevFilters, machineFilter: value };
              })
            }
            size="small"
            fullWidth
          />
        </DropdownWrapper>
      </DropdownGroup>
      <DateGroup>
        <DropdownWrapper>
          <StartDatePicker
            startDate={startDateFilter}
            endDate={endDateFilter}
            onChange={value =>
              onFilterChange(prevFilters => {
                return { ...prevFilters, startDateFilter: value };
              })
            }
            label={startDateLabel}
            size="small"
            clearable
          />
        </DropdownWrapper>
        <DropdownWrapper>
          <EndDatePicker
            startDate={startDateFilter}
            endDate={endDateFilter}
            onChange={value =>
              onFilterChange(prevFilters => {
                return { ...prevFilters, endDateFilter: value };
              })
            }
            label={endDateLabel}
            size="small"
            clearable
          />
        </DropdownWrapper>
      </DateGroup>
    </Row>
  );
}

AlertTableControls.propTypes = {
  filters: PropTypes.object,
  onFilterChange: PropTypes.func,
  startDateLabel: PropTypes.string,
  endDateLabel: PropTypes.string
};

const Row = styled("div")`
  display: flex;
  flex-direction: row;
  gap: ${props => props.theme.spacing(1)};
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
`;

const DropdownGroup = styled("div")`
  display: flex;
  flex-direction: row;
  gap: ${props => props.theme.spacing(1)};
  flex-grow: 3;
`;

const DateGroup = styled("div")`
  display: flex;
  flex-direction: row;
  gap: ${props => props.theme.spacing(1)};
  justify-content: flex-end;
  flex-grow: 2;
`;

const DropdownWrapper = styled("div")`
  display: flex;
  min-width: ${props => props.theme.spacing(15)};
  max-width: ${props => props.theme.spacing(22)};
  flex-grow: 1;
`;
